import { isHTMLElement as s, getOwnerDocument as n } from "../dom/index.js";
const i = (t) => t.hasAttribute("tabindex"), u = (t) => i(t) && t.tabIndex === -1, c = (t) => !!t.getAttribute("disabled") || !!t.getAttribute("aria-disabled"), l = (t) => s(t) && t.tagName.toLowerCase() === "input" && "select" in t, h = (t) => (s(t) ? n(t) : document).activeElement === t, o = (t) => t.parentElement && o(t.parentElement) ? !0 : t.hidden, e = (t) => {
  const r = t.getAttribute("contenteditable");
  return r !== "false" && r != null;
}, b = (t) => {
  if (!s(t) || o(t) || c(t))
    return !1;
  const { localName: r } = t;
  if (["input", "select", "textarea", "button"].indexOf(r) >= 0) return !0;
  const a = {
    a: () => t.hasAttribute("href"),
    audio: () => t.hasAttribute("controls"),
    video: () => t.hasAttribute("controls")
  };
  return r in a ? a[r]() : e(t) ? !0 : i(t);
}, g = (t) => t ? s(t) && b(t) && !u(t) : !1;
export {
  u as hasNegativeTabIndex,
  i as hasTabIndex,
  h as isActiveElement,
  e as isContentEditable,
  c as isDisabled,
  b as isFocusable,
  o as isHidden,
  l as isInputElement,
  g as isTabbable
};
//# sourceMappingURL=index.js.map
